<div class="invoice-container" [class.pdf-mode]="forPdf" *ngIf="statement">
  <div class="invoice-header">
    <div class="company-brand">
      <h1>ARTIST STATEMENT</h1>
      <p>{{ statement.companyName }}</p>
      <p>6980 Beach Blvd., H-110, Buena Park, CA 90621 (714) 349-8856</p>
    </div>
    <div class="invoice-meta">
      <div class="meta-group" *ngIf="statement.statementNumber"><label>Statement #</label><span>{{ statement.statementNumber }}</span></div>
      <div class="meta-group"><label>{{ statement.issuedAt ? 'Issued Date' : 'Generated Date' }}</label><span>{{ (statement.issuedAt || today) | date:'mediumDate' }}</span></div>
      <div class="meta-group"><label>Statement Period</label><span>{{ statement.period }}</span></div>
    </div>
  </div>

  <div class="invoice-body">
    <div class="bill-to">
      <h3>{{ statement.source === 'automated' ? 'Pay To:' : 'Statement For:' }}</h3>
      <p><strong>{{ statement.artistName }}</strong></p>
    </div>

    <table class="invoice-table">
      <thead>
        <tr>
          <th>Frame ID</th>
          <th>Image</th>
          <th class="text-center">Quantity</th>
          <th class="text-right">Commission</th>
          <th class="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of statement.items" class="print-row">
          <td>{{ item.frameId }}</td>
          <td>
            <img *ngIf="item.frameImage" [src]="item.frameImage" class="thumbnail-img" crossorigin="anonymous">
            <span *ngIf="!item.frameImage" class="no-image">N/A</span>
          </td>
          <td class="text-center">{{ item.quantity }}</td>
          <td class="text-right">{{ rateMissing ? 'Rate missing' : (item.commission | currency) }}</td>
          <td class="text-right">{{ rateMissing ? 'Rate missing' : (item.total | currency) }}</td>
        </tr>
        <tr *ngIf="!statement.items || statement.items.length === 0">
          <td colspan="5" class="empty-msg">No statement items.</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-row">
          <td colspan="4" class="text-right">Grand Total</td>
          <td class="text-right total-due-cell">{{ rateMissing ? 'Rate missing' : (statement.totalAmount | currency) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
